export default function LoadingView() {
    return <div>Loading...</div>;
}
